export const PROD_KEY_PREFIX = "prod::"
export const PROD_QTY_KEY_PREFIX = "qty-prod::"

export const getProductDetailsSet = (objWithProducts) => {
  let productList = new Set()
  for (let key in objWithProducts) {
    if (key.startsWith(PROD_QTY_KEY_PREFIX)) {
      // In some case, there may be product quantity on a shelf or order object, but not
      //  product weight. This case handles that.
      let prodIdWithPrefix = key.replace(PROD_QTY_KEY_PREFIX, PROD_KEY_PREFIX)
      productList.add(prodIdWithPrefix)
    }
  }
  return productList
}

export const productWeightToQuantity = (productTotalWeight, productUnitWeight) => {
  console.log(
    "product.productWeightToQuantity(productTotalWeight, productUnitWeight)",
    productTotalWeight,
    productUnitWeight
  )
  let quantity = 0
  if (productTotalWeight > 0) {
    quantity = Math.round(productTotalWeight / productUnitWeight)
  }
  return quantity
}

export const removeProdKey = (prodId) => {
  let newProdId
  if (prodId) {
    newProdId = prodId.replace(PROD_KEY_PREFIX, "")
  }
  return newProdId
}

export const createCartProdArray = (order, products) => {
  let items = []
  // calculate product quantity from product weight
  if (order && products) {
    for (var key in order) {
      if (key.startsWith(PROD_QTY_KEY_PREFIX)) {
        let prodIdWithPrefix = key.replace(PROD_QTY_KEY_PREFIX, PROD_KEY_PREFIX)
        if (products[prodIdWithPrefix]) {
          let qty = Number(order[key])
          if (qty !== 0) {
            items.push({ key: prodIdWithPrefix, name: products[prodIdWithPrefix].name, qty: qty })
          }
        }
      }
    }
  }
  return items
}
